import CodeMirror from 'codemirror';
import { getTooltipNode } from '../markers/utils';
import { createTooltip } from '../components/tooltip';


// 如果节点被设置了`editor-tooltip`属性，则`hover`时显示错误信息
export default function addTooltipEventListener(container: HTMLDivElement) {
  CodeMirror.on(container, 'mouseover', (evt: MouseEvent) => {
    const target = (evt.target || evt.srcElement) as HTMLElement;
    if (target) {
      const nodeResult = getTooltipNode(target, container);
      if (nodeResult) {
        const destroy = createTooltip({
          title: nodeResult.tooltip
        }, target);
        nodeResult.node.addEventListener('mouseleave', () => {
          destroy();
        }, false);
      }
    }
  });
}
